import { css } from '@emotion/react';
import { Animation, Colors, Heading, HeadingLevel, Link, Spacer, Text, Typography, } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
import { ArrowLinkIcon } from '../MegaMenuSubmenu';
const Styles = {
    root: css(Object.assign({ color: Colors.neutral800 }, Typography.smallPrint1Bold)),
    listItem: css({
        marginBottom: 8,
        '&:last-of-type': {
            marginBottom: 0,
        },
    }),
    link: css(Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.neutral800, transition: `text-decoration 100ms ${Animation.transitionTimingFunction}`, textDecoration: 'none', '&:hover': {
            textDecoration: 'underline',
            color: Colors.neutral800,
        }, '&:hover > span': {
            marginLeft: 4,
            opacity: 1,
        }, '&:focus': {
            outline: `1px solid ${Colors.blue}`,
            color: Colors.neutral800,
        } })),
};
export const ListPromo = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `ListPromo: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return (isolateComponent("section", { css: Styles.root },
        props.text && (isolateComponent(HeadingLevel, null,
            isolateComponent(Heading, null,
                isolateComponent(Text, { type: "smallPrint1Bold" }, props.text)),
            isolateComponent(Spacer, { height: 20 }))),
        isolateComponent("ul", null, props.links.map((link) => (isolateComponent("li", { key: link.text, css: Styles.listItem },
            isolateComponent(Link, { color: null, css: Styles.link, href: getFullyQualifiedURL(link.href) || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
                link.text,
                isolateComponent(ArrowLinkIcon, null))))))));
};
//# sourceMappingURL=ListPromo.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
